// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import './common/element-ui/components.js'

import './common/styles/normalize.css'
import './common/styles/index.scss'
import './common/styles/base.less'

import global from './common/global/index.js'
global.init(Vue)

import './icons'
import './permission'

import * as filters from './common/filters/index.js'
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

import hook from 'zgkaihu/lib/hook'
import { uploadFile } from './common/services/upload'
hook.hook(Vue, {
  $post: Vue.prototype.$post,
  $get: Vue.prototype.$get,
  $uploadFile: uploadFile,
  $convertResp: function(data) {
    return { success: data.success, data: data.data[0] }
  },
  $convertFile: filters.fileUrlAdapter
})

import 'viewerjs/dist/viewer.css'
import '@/directives/index'

import SvgIcon from '@/components/SvgIcon/index.vue'
Vue.component('svg-icon', SvgIcon)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
